import React from 'react';
import { Camp } from '../../utils/types';
import { CampFormatUtils } from '../../utils/campFormatUtils';

interface CampDatesDropdownProps {
  camp: Camp;
  selectedDate?: string;
  onDateChange?: (campId: string, dateId: string) => void;
  scheduledDateIds?: string[];
}

const CampDatesDropdown: React.FC<CampDatesDropdownProps> = ({
  camp,
  selectedDate,
  onDateChange,
  scheduledDateIds
}) => {

  const scheduledIdsSet = new Set((scheduledDateIds || []).map((id) => String(id)));

  const getEffectiveSelectedDate = () => {
    if (selectedDate) return selectedDate;
    if (camp.camp_dates.length === 1) return camp.camp_dates[0].id;

    // If there are scheduled dates, select the first one
    if (scheduledDateIds && scheduledDateIds.length > 0) {
      const sortedDates = [...camp.camp_dates].sort(
        (a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
      );
      const firstScheduled = sortedDates.find(date => scheduledIdsSet.has(String(date.id)));
      if (firstScheduled) return firstScheduled.id;
    }

    return '';
  };

  const effectiveSelectedDate = getEffectiveSelectedDate();

  if (camp.camp_dates.length === 1) {
    return (
      <span className="detail-text">
        {CampFormatUtils.formatDateRange(camp.camp_dates[0].start_date, camp.camp_dates[0].end_date)}
      </span>
    );
  }

  return (
    <div className="date-dropdown-container">
      <select
        className="date-dropdown custom-select"
        value={effectiveSelectedDate || ''}
        onChange={(e) => {
          e.stopPropagation();
          if (onDateChange) {
            onDateChange(camp.id, e.target.value);
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <option value="">Multiple dates available</option>
        {camp.camp_dates
          .sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime())
          .map((campDate) => {
            const isScheduled = scheduledIdsSet.has(String(campDate.id));
            return (
              <option key={campDate.id} value={campDate.id}>
                {CampFormatUtils.formatDateRange(campDate.start_date, campDate.end_date)}
                {isScheduled ? ' (Scheduled)' : ''}
              </option>
            );
          })}
      </select>
    </div>
  );
};

export default CampDatesDropdown;
